// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"251c94e5","295":"81eef3c2","328":"8d1bf786","331":"f34a7b71","333":"6596f410","527":"2d2b1c34","634":"c9af266e","655":"b6d20fff","724":"7320d2aa","947":"7e39bd78"}[chunkId] + ".chunk.js";
};